import { AxiosRequestConfig } from 'axios'

import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'
import { Culture } from '@/types/culture'
import { Treatment } from '@/types/treatment'

export async function confirmReportResolution(
  treatment: Treatment,
  culture: Culture,
  diagnosisId: string,
  reportId: string,
  config?: AxiosRequestConfig,
) {
  await companiesApi.put(
    apiRoutes.reportResolution(treatment, culture, diagnosisId, reportId),
    undefined,
    config,
  )
}
